export var Issuer;
(function (Issuer) {
  Issuer['JWT'] = 'JWT';
})(Issuer || (Issuer = {}));
